<template>
	<div>
    <label-tag :tagArray="[$t('conversation_mission')]" :previous="true" @previousPage="goVrIndex"/>
    <div class="m-5 " style=" text-align: left;">
      <select v-model="currentScene">
        <option v-for="(item, index) in sceneList" @change="goPage(item.id)" :value="item.id" :key="index">{{item.name}}</option>
      </select>
    </div>
		<div class="m-5" style="overflow: auto; min-height:50vh" >
			<table class="table table-borderless table-hover">
				<thead>
					<tr>
						<th>{{$t('title')}}</th>
						<th>{{$t('scene')}}</th>
            <th>{{$t('character')}}</th>
            <th>{{$t('chance')}}</th>
            <th>{{$t('standard_score')}}</th>
            <th>{{$t('mistake')}}</th>
            <th>{{$t('display')}}</th>
            <th>{{$t('function')}}</th>
					</tr>
				</thead>
				<br>
				<tbody style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;">
					<tr  v-for="(el ,index) in dialogsInfo" :key="index">
						<th>
              <input v-model="el.title" type="text" :placeholder="$t('input_name')">
						</th>
            <td>
              <v-select style="min-width:200px;" v-model="el.situationId" :reduce="title => title.value" :options="options" :label="locale==='tw'?'text':'textEn'">
                <template  slot="option" :value="option.value" class="d-flex justify-content-between" slot-scope="option">
                  <div v-if="locale==='tw'" class="d-flex">
                    <div style="width:50%">
                      {{option.title}}
                    </div>
                  </div>
                  <div v-else class="d-flex">
                    <div style="width:50%">
                      {{option.textEn }}
                    </div>
                  </div>
                  <div style="width:80%">
                    <img style="width:125px;!important" :src="option.image" />
                  </div>
                </template>
              </v-select>
						</td>
            <td>
							<select v-if="sceneInfo" v-model="el.roleId">
								<option v-for="(item, index) in sceneInfo.roles" :value="item.value" :key="index">
                  <span v-if="locale==='tw'">{{item.text}}</span>
                  <span v-else>{{item.textEn}}</span>
                </option>
							</select>
						</td>
            <td>
							<input v-model="el.repetTimes" min="0" max="99" type="number" name="" id="">
						</td>
            <td>
							<input v-model="el.passScore" min="0" max="99" type="number" name="" id="">
						</td>
            <td>
              <input v-model="el.failedCutScore" min="0" max="99" type="number" name="" id="">
						</td>
            <td>
              <toggle-button v-model="el.isEnable"
                :sync="true"
                :labels="{checked: 'On', unchecked: 'Off'}"
                :color="{checked: '#5dceb0', unchecked: '#6e817f'}"
                :disabled=" enableCount === 5 && !el.isEnable"
                />
            </td>
            <td>
              <span @click="goEditPage(el)" class="pointer control-btn">{{$t('edit')}}</span>
              <span @click="removeCustomDialogs(el)" class="pointer control-btn">{{$t('delete')}}</span>
            </td>
					</tr>
				</tbody>
			</table>
      <div style="text-align: left;">
        <button type="button" @click="addConversation" class="btn btn-primary">{{$t('add')}}</button>
      </div>
		</div>
    <div class="mx-5" style="text-align: right;">
      <button type="button" @click="reset" class="btn btn-primary">{{$t('cancel')}}</button>
      <button type="button" @click="addCustomDialogs" class="btn btn-primary">{{$t('save')}}</button>
    </div>
	</div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import swal from 'bootstrap-sweetalert'
import api from '../../../store/api'
import labelTag from './Label'
export default {

  name: 'Conversation',

  data () {
    return {
      locale: window.localStorage.getItem('locale'),
      sceneList: [],
      sceneInfo: null,
      currentScene: 0,
      options: [],
      dialogsInfo: [],
      dialogslength: 20,
      enableCount: 0
    }
  },
  components: {
    labelTag,
    ToggleButton
  },
  async mounted () {
    await this.getSceneList()
    await this.getSceneInfo()
    await this.getCustomDialogs()
  },
  watch: {
    currentScene (val) {
      if (val) {
        this.$router.push({ path: val })
        this.getSceneInfo()
        this.getCustomDialogs()
      }
    },
    dialogsInfo: {
      handler (val) {
        let Enable = val.filter((el) => {
          return el.isEnable
        })
        this.enableCount = Enable.length
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async getSceneList () {
      const { data } = await api.get(`/VR/Scene`)
      this.sceneList = data.data
      this.currentScene = data.data[0].id
      this.$router.push({ path: data.data[0].id })
    },
    async getSceneInfo () {
      const { data } = await api.get(`/VR/Scene/${this.$route.params.id}/Info`)
      this.sceneInfo = data.data
      let vm = this
      this.options = []
      data.data.situations.map((el, idx) => {
        vm.options[idx] = el
        vm.options[idx].title = el.text
      })
    },
    addConversation () {
      let dialogInfo = {
        title: '',
        situationId: 0,
        roleId: 0,
        repetTimes: 0,
        passScore: 0,
        failedCutScore: 0,
        isEnable: false
      }
      if (this.dialogsInfo.length < this.dialogslength) {
        this.dialogsInfo.push(dialogInfo)
      }
    },
    async getCustomDialogs () {
      let params = {
        sceneId: this.$route.params.id
      }
      const { data } = await api.get(`/VR/CustomDialogs`, {params})
      this.dialogsInfo = data.data
    },
    async addCustomDialogs () {
      let params = {
        sceneId: this.$route.params.id
      }
      const { data } = await api.patch(`/VR/CustomDialogs`, this.dialogsInfo, {params})
      console.log(data)
      this.getCustomDialogs()
      swal(this.$t('saved_successfully') + '!', this.$t('added_mission'), 'success')
    },
    deleteCustomDialogs  (id) {
      let self = this
      swal({
        title: this.$t('deleting_confirm'),
        text: this.$t('warming_remind'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('cancel'),
        closeOnConfirm: false
      },
      async function () {
        const { data } = await api.delete(`/VR/CustomDialogs/${id}`)
        if (data.status === 'OK') {
          self.getCustomDialogs()
          swal(self.$t('deleted'), self.$t('class_deleted'), 'success')
        }
      })
    },
    goEditPage (el) {
      this.$router.push({name: 'conversation_edit', params: { id: el.id }})
    },
    removeCustomDialogs (el) {
      if (el.id) {
        this.deleteCustomDialogs(el.id)
      } else {
        this.dialogsInfo.pop()
      }
    },
    reset () {
      this.getCustomDialogs()
      this.dialogsInfo.splice(0, 1, this.dialogsInfo[0])
    },
    goVrIndex () {
      this.$router.push({name: 'VRIndex'})
    }
  }
}
</script>

<style lang="scss" scoped>
	table {
    text-align: left;
    // font-size: 1.25rem;
    select, input {
      height: 2rem;
      min-width: 80px;
    }
  }
  select, input {
    border: rgba(0, 0, 0, 0.205) 1px solid;
    border-radius: 4px;
    outline: none;
    padding: 2px;
  }
  .control-btn {
    color: blue;
    text-decoration: underline;
  }


</style>


// WEBPACK FOOTER //
// ConversationMission.vue?2475e8d9